import { useEffect, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';
import { seasonSidelinedCollection } from '../services/sidelined.js';

/**
 * Live map van blessures en schorsingen voor een seizoen.
 *
 * Laadt `seasons/{seasonId}/sidelined` en levert een `Map` waarin je op
 * `String(player.id)` de status van een speler opzoekt. De sleutel is bewust een
 * string: `playerId` staat als number in Firestore, maar de speler-id's in de
 * frontend worden overal als string vergeleken.
 *
 * Bedoeld om één keer per scherm/pop-up aangeroepen te worden; de losse
 * `PlayerCard`-kaartjes krijgen hun status als prop, zodat het kaartje zelf geen
 * data ophaalt.
 *
 * @param {string|number|null|undefined} seasonId
 * @return {Map<string, object>} Map van speler-id (string) naar sidelined-record.
 */
export function useSidelinedMap(seasonId) {
    const [sidelinedMap, setSidelinedMap] = useState(() => new Map());

    useEffect(() => {
        if (!seasonId) {
            setSidelinedMap(new Map());
            return undefined;
        }

        const unsub = onSnapshot(
            seasonSidelinedCollection(seasonId),
            (snap) => {
                const next = new Map();
                snap.forEach((docSnap) => {
                    const record = docSnap.data();
                    if (record?.playerId != null) {
                        next.set(String(record.playerId), record);
                    }
                });
                setSidelinedMap(next);
            },
            (err) => {
                console.error('Kon blessures/schorsingen niet live bijwerken:', err);
                setSidelinedMap(new Map());
            },
        );

        return unsub;
    }, [seasonId]);

    return sidelinedMap;
}

export default useSidelinedMap;
